<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>

<div id="header-container">
  <h3 id="header-text" class="align-self-end pb-1">Propulsion Portfolio Report</h3>
  <div class="d-flex gap-8 pb-1 align-items-center">
    <button mat-flat-button color="primary" id="run-report-button" class="action-button"
            (click)="getPortfolioReport()"
            [disabled]="fcorgs.selectedOptions.length === 0">
      Run Report
    </button>
  </div>
</div>

<div class="d-flex flex-column gap-16">
  <div class="d-flex flex-row gap-8">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label class="asterisk--before">Portfolio Type</mat-label>
      <mat-select [(ngModel)]="selectedPortType" id="port-type-select" (selectionChange)="onPortTypeChange()">
        <mat-option *ngFor="let portType of portTypes" [value]="portType">
          {{ portType.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="fcorg-filter" subscriptSizing="dynamic">
      <mat-label>Forecast Org</mat-label>
      <fab-multiselect
        [(ngModel)]="fcorgs.selectedOptions"
        (ngModelChange)="getFilters()"
        [options]="fcorgs.options">
      </fab-multiselect>
    </mat-form-field>
    <mat-checkbox [(ngModel)]="dateAudit">
      Include Date Audit Fields
    </mat-checkbox>
  </div>

  <div class="d-flex flex-column gap-8">
    <h3>Filter By:</h3>
    <div class="d-flex flex-row gap-8">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Region</mat-label>
        <fab-multiselect
          [(ngModel)]="regions.selectedOptions"
          (ngModelChange)="onFilterChange(REGION)"
          [options]="regions.options"
          [disabled]="fcorgs.selectedOptions.length === 0">
        </fab-multiselect>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Subregion</mat-label>
        <fab-multiselect
          [(ngModel)]="subregions.selectedOptions"
          (ngModelChange)="onFilterChange(SUBREGION)"
          [options]="subregions.options"
          [disabled]="fcorgs.selectedOptions.length === 0">
        </fab-multiselect>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Planning Market</mat-label>
        <fab-multiselect
          [(ngModel)]="planningMarkets.selectedOptions"
          (ngModelChange)="onFilterChange(PLNGMKT)"
          [options]="planningMarkets.options"
          [disabled]="fcorgs.selectedOptions.length === 0">
        </fab-multiselect>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Architecture</mat-label>
        <fab-multiselect
          [(ngModel)]="architectures.selectedOptions"
          (ngModelChange)="onFilterChange(ARCH)"
          [options]="architectures.options"
          [disabled]="fcorgs.selectedOptions.length === 0">
        </fab-multiselect>
      </mat-form-field>
    </div>

    <div class="d-flex flex-row gap-8">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Program Code</mat-label>
        <fab-multiselect
          [(ngModel)]="programCodes.selectedOptions"
          (ngModelChange)="onFilterChange(PRGMCODE)"
          [options]="programCodes.options"
          [disabled]="fcorgs.selectedOptions.length === 0">
        </fab-multiselect>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Body Style</mat-label>
        <fab-multiselect
          [(ngModel)]="bodyStyles.selectedOptions"
          (ngModelChange)="onFilterChange(BODYSTYLE)"
          [options]="bodyStyles.options"
          [disabled]="fcorgs.selectedOptions.length === 0">
        </fab-multiselect>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Engine Family</mat-label>
        <fab-multiselect
          [(ngModel)]="engineFams.selectedOptions"
          (ngModelChange)="onFilterChange(ENGFAM)"
          [options]="engineFams.options"
          [disabled]="fcorgs.selectedOptions.length === 0">
        </fab-multiselect>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Transmission Family</mat-label>
        <fab-multiselect
          [(ngModel)]="transmissionFams.selectedOptions"
          (ngModelChange)="onFilterChange(TRANFAM)"
          [options]="transmissionFams.options"
          [disabled]="fcorgs.selectedOptions.length === 0">
        </fab-multiselect>
      </mat-form-field>
    </div>
  </div>
</div>
